import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

import {type RootState} from 'stores/redux_store';

export type PushSubscriptionState = {
    hasSubscription: boolean;
    wasNotificationsPermissionRequested: boolean;
    showNotificationsPermissionGuide: boolean;
}

const initialState: PushSubscriptionState = {
    hasSubscription: false,
    showNotificationsPermissionGuide: false,
    wasNotificationsPermissionRequested: false,
};

export const pushSubscriptionSlice = createSlice({
    name: 'pushSubscription',
    initialState,
    reducers: {
        setSubscription: (state) => {
            state.hasSubscription = true;
        },
        removeSubscription: (state) => {
            state.hasSubscription = false;
        },
        setShowNotificationsPermissionGuide: (state) => {
            state.showNotificationsPermissionGuide = true;
        },
        setCloseNotificationsPermissionGuide: (state) => {
            state.showNotificationsPermissionGuide = false;
        },
        setNotificationsPermissionRequested: (state, action: PayloadAction<boolean>) => {
            state.wasNotificationsPermissionRequested = action.payload;
        },
    },
});

export const getShowNotificationsPermissionGuide = (state: RootState) =>
    state.pushSubscription.showNotificationsPermissionGuide;

export const getNotificationsPermissionRequested = (state: RootState) =>
    state.pushSubscription.wasNotificationsPermissionRequested;

export const {
    setSubscription,
    removeSubscription,
    setShowNotificationsPermissionGuide,
    setCloseNotificationsPermissionGuide,
    setNotificationsPermissionRequested,
} = pushSubscriptionSlice.actions;
